import { Enabled, QueryKey, QueryOptions, useQuery } from '@tanstack/react-query';

import { getBestTrait } from '@/api/loans';
import { INFTBestTrait } from '@/redux/loans/model';
import { GET_BEST_TRAIT } from '@/utils/queryKey';

interface QueryOptionsBestTrait extends QueryOptions<INFTBestTrait> {
  enabled?: Enabled<INFTBestTrait, Error, INFTBestTrait, QueryKey>;
}

export const useBestTrait = (contractAddress: string | undefined, tokenId: string | undefined, queryProps?: QueryOptionsBestTrait) => {
  return useQuery({
    queryKey: [GET_BEST_TRAIT, contractAddress, tokenId],
    queryFn: () => getBestTrait(contractAddress!, tokenId!),
    enabled: !!contractAddress && !!tokenId,
    ...queryProps,
  });
};
